<template>
  <v-container
    fluid
    class="signup-request-white auth fill-height d-flex flex-row align-center"
  >
    <v-row>
      <v-col md="4" sm="12" offset-md="4">
        <v-card class="pa-5">
          <Logo class="my-5" height="150" />
          <v-card-text class="text-justify mt-4 pb-0">
            <v-alert
              v-if="$store.getters['Auth/alert'].status"
              outlined
              dense
              border="left"
              :type="
                $store.getters['Auth/alert'].status === 'success'
                  ? 'success'
                  : 'error'
              "
              class="mb-10"
            >
              {{ $store.getters["Auth/alert"].message }}
            </v-alert>

            <v-text-field
              ref="email"
              v-model="formData.email"
              dense
              outlined
              @copy.prevent
              @paste.prevent
              type="email"
              label="Email Address"
              placeholder="Enter your Email Address"
              :rules="rules.email"
            />
          </v-card-text>

          <v-card-actions class="">
            <v-row>
              <v-col cols="12">
                <span class="">Already have an account?</span>
                <router-link
                  :to="{ name: 'SignIn' }"
                  class="text-decoration-none"
                >
                  Sign In
                </router-link>
              </v-col>
              <v-col cols="12">
                <v-btn color="primary" block @click="reset">
                  Send Login Link
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RouterMixin from "../../../mixin/RouterMixin";
import Logo from "../../../components/Logo";

export default {
  name: "ForgotPassword",
  components: { Logo },
  mixins: [RouterMixin],
  data: function () {
    return {
      formData: {
        email: "",
      },
    };
  },

  computed: {
    rules() {
      return {
        email: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
      };
    },
  },

  methods: {
    reset: function () {
      let isValid = true;
      for (const key in this.formData) {
        isValid = isValid ? this.$refs[key].validate(true) : false;
      }

      if (isValid) {
        this.$store.dispatch("Auth/forgotPassword", { ...this.formData });
      }
    },
  },
};
</script>

<style scoped></style>
